import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

const Loading = ({ 
  size = 'md',
  text,
  className,
  type = 'spinner'
}) => {
  const { t } = useTranslation()
  
  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  }

  const Spinner = () => (
    <svg 
      className={clsx('animate-spin', sizes[size])} 
      xmlns="http://www.w3.org/2000/svg" 
      fill="none" 
      viewBox="0 0 24 24"
    >
      <circle 
        className="opacity-25" 
        cx="12" 
        cy="12" 
        r="10" 
        stroke="currentColor" 
        strokeWidth="4"
      />
      <path 
        className="opacity-75" 
        fill="currentColor" 
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  )

  const Dots = () => (
    <div className="flex space-x-1">
      <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
      <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
      <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce"></div>
    </div>
  )

  return (
    <div className={clsx('flex flex-col items-center justify-center p-4', className)}>
      {type === 'spinner' ? <Spinner /> : <Dots />}
      {text && (
        <p className="mt-2 text-sm text-gray-600">
          {text || t('common.loading')}
        </p>
      )}
    </div>
  )
}

export default Loading 